import { Box, Typography, styled } from "@mui/material";

export const StyledBannerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.regular,
  width: "100%",
  border: theme.borders.highlighted,
  padding: "15px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    textAlign: "center",
  },
}));

export const StyledTextContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  paddingLeft: "15px",
  gap: "4px",
}));

const greetingTypography = (theme) => ({
  fontFamily: '"Clash Display", sans-serif !important',
  fontSize: theme.typography.extraLarge.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  lineHeight: 1.35,
  color: theme.palette.text.primary,
  [theme.breakpoints.down("xl")]: {
    fontSize: theme.typography.base.fontSize,
  },
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.regular.fontSize,
  },
});

// --------------------

const ClashDisplayFont = `
  @font-face {
    font-family: "Clash Display";
    src: url("/fonts/ClashDisplay-Regular.woff2") format("woff2");
    font-weight: normal;
    font-style: normal;
  }
`;
// Styled Component

export const StyledHeading = styled(Typography)(({ theme }) => ({
  ...greetingTypography(theme),
  display: "flex",
  alignItems: "center",
}));

const styleTag = document.createElement("style");
styleTag.innerHTML = ClashDisplayFont;
document.head.appendChild(styleTag);

export const StyledSubText = styled(Typography)(({ theme }) => ({
  ...greetingTypography(theme),
}));

export const StyledHighlightedText = styled("span")(({ theme }) => ({
  ...greetingTypography(theme),
}));

export const StyledImageContainer = styled(Box)(({ theme, isMobile }) => ({
  width: "55%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  marginTop: isMobile ? "20px" : "0",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));
export const StyledBannerImage = styled("img")(({ theme }) => ({
  width: "100%",
  borderRadius: theme.borderRadius.radius.medium,
  height: "150px",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
  },
}));
export const StyledShippingImg = styled("img")(({ theme }) => ({
  position: "absolute",
  bottom: "26px",
  left: "24px",
  width: "257px",
  height: "39px",

  [theme.breakpoints.down("xl")]: {
    width: "190px",
    left: "20px",
    bottom: "10px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "155px",
    left: "15px",
    bottom: "8px",
  },
  [theme.breakpoints.down("xs")]: {
    width: "140px",
    left: "10px",
    bottom: "8px",
  },
}));
